import ProfileCardsSection from './profileCardsSection';

export { profileCardsSectionType } from './profileCardsSection.types';
export { profileCardsSectionFragment } from './profileCardsSection.fragment';
export { profileCardsSectionStandard } from './__fixtures__/profileCardsSection';

export default ProfileCardsSection;
